import {defineStore} from "pinia";

const STORAGE_KEY = "widget_configuration_context";

function getInitialState() {
    try {
        const raw = sessionStorage.getItem(STORAGE_KEY);
        if (!raw) {
            return {
                aiAgentId: null,
                widgetId: null,
                widgetName: "",
                isActive: true,
            };
        }

        const parsed = JSON.parse(raw);
        return {
            aiAgentId: parsed.aiAgentId || null,
            widgetId: parsed.widgetId || null,
            widgetName: parsed.widgetName || "",
            isActive: parsed.isActive !== false,
        };
    } catch {
        return {
            aiAgentId: null,
            widgetId: null,
            widgetName: "",
            isActive: true,
        };
    }
}

export const useWidgetConfigurationStore = defineStore("widgetConfiguration", {
    state: () => getInitialState(),
    actions: {
        persist() {
            sessionStorage.setItem(
                STORAGE_KEY,
                JSON.stringify({
                    aiAgentId: this.aiAgentId,
                    widgetId: this.widgetId,
                    widgetName: this.widgetName,
                    isActive: this.isActive,
                }),
            );
        },
        setContext({aiAgentId, widgetId, widgetName = "", isActive = true}) {
            this.aiAgentId = aiAgentId || null;
            this.widgetId = widgetId || null;
            this.widgetName = widgetName || "";
            this.isActive = Boolean(isActive);
            this.persist();
        },
        clearContext() {
            this.aiAgentId = null;
            this.widgetId = null;
            this.widgetName = "";
            this.isActive = true;
            sessionStorage.removeItem(STORAGE_KEY);
        },
    },
});
